import type { BaseServerData } from '@freelancer/datastore/core';

export enum OnlineOfflineUserStatusValueApi {
  OFFLINE = 1,
  ONLINE = 2,
}

/**
 * Base Notifications event definition which all online/offline events should
 * extend from.
 */
export interface BaseServerOnlineOfflineData<C> extends BaseServerData<C> {
  readonly parent_type: 'onlineoffline';
}

export type WebsocketOnlineOfflineEvent =
  | WebsocketOnlineOfflineSubscribeEvent
  | WebsocketOnlineOfflineStatusChangeEvent;

interface WebsocketOnlineOfflineSubscribeEventData {
  readonly [userId: string]: OnlineOfflineUserStatusValueApi;
}

export interface WebsocketOnlineOfflineSubscribeEvent
  extends BaseServerOnlineOfflineData<WebsocketOnlineOfflineSubscribeEventData> {
  readonly type: 'statusget';
}

interface WebsocketOnlineOfflineStatusChangeEventData {
  readonly from: OnlineOfflineUserStatusValueApi;
  readonly timestamp: number;
  readonly to: OnlineOfflineUserStatusValueApi;
  readonly user: number;
}

export interface WebsocketOnlineOfflineStatusChangeEvent
  extends BaseServerOnlineOfflineData<WebsocketOnlineOfflineStatusChangeEventData> {
  readonly type: 'statuschange';
}
